import { Typography } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import DeleteIcon from '@material-ui/icons/Delete';
import PropTypes from 'prop-types';
import React from 'react';
import { DragSource } from 'react-dnd';
import LanguageAvatar from '../LanguageAvatar';
import { globalStyles } from '../style/gstheme';
import ResourceLorem from './ResourceLorem';

const styles = theme => {
    return Object.assign({
        headerBox: {
            height: 40,
            width: '100%',
            borderBottom: 'solid 1px #9e9e9e'
        },
        optionHeader: {
            display: 'inline-block',
            whiteSpace: 'nowrap',
            marginRight: 12,
            marginLeft: 12,
            overflow: 'hidden',
            paddingTop: 4,
            transform: 'translateY(6px)',
            textOverflow: 'ellipsis'
        },
        optionLanguage: {
            color: 'white',
            textAlign: 'right',
            display: 'inline-block'
        },
        optionDelete: {
            width: 30,
            display: 'inline-block'
        },
        textBoxExample: {
            paddingLeft: 12,
            paddingTop: 4,
            paddingBottom: 0,
            height: 20,
            backgroundColor: '#f5f5f5',
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            borderBottom: 'solid 1px #9e9e9e'
        },
        textBox: {
            height: 28,
            paddingLeft: 12,
            paddingRight: 12,
            paddingTop: 12,
            overflow: 'hidden',
            whiteSpace: 'nowrap',
            borderBottom: 'solid 1px #9e9e9e'
        },
        tsvOption: {
            backgroundColor: '#ffffff',
            borderRadius: 4,
            borderLeft: 'solid 1px #9e9e9e',
            borderRight: 'solid 1px #9e9e9e',
            borderTop: 'solid 1px #9e9e9e',
            float: 'left',
            width: 220,
            height: 188,
            boxShadow: '0px 1px 3px #00000029',
            '&:hover': {
                boxShadow: '0px 12px 17px #00000029'
            }
        }
    }, globalStyles);
};

const Types = {
    TSVPROP: 'TsvProp'
};

const tsvPropSource = {
    beginDrag(props) {
        props.beginDragging(props.index);
        return {
            index: props.index,
            type: "TsvProp"
        };
    },
    endDrag(props) {
        props.endDragging(props.index);
        return {
            index: props.index,
            type: "TsvProp"
        };
    }
};


function collectSource(connect) {
    return {
        connectDragSource: connect.dragSource()
    };
}

class TSVselectedOption extends React.Component {

    render() {

        const { classes, property, lang, showLang, removeOption, options, isDraggable, disabled,
            connectDragSource, defaultLang, labelProp, dragging, examples, graph } = this.props;
        const titleResource = options.find(option => option.iri === property);
        const title = titleResource ? titleResource.label : property;
        
        const tsvOption = <div data-test="column-info" className={classes.tsvOption}
            style={dragging ?
                { border: 'solid 2px #97D700', opacity: 0.2 }
                :
                {
                    margin: 1,
                    ...(isDraggable) && { cursor: 'grab' },
                    ...(!titleResource) && { border: 'solid 1px #CA4F0C' }
                }
            }>
            <div className={classes.headerBox}>
                <div
                    data-test="column-title"
                    className={classes.optionHeader}
                    style={{
                        width: lang.length > 2 ? 114 : 130,
                    }}>
                    <Tooltip title={property === "https://grafsync.graphifi.com/schema/tsv/hierarchy" ?
                        "Hierarchy will output all levels of the taxonomy across multiple columns"
                        :
                        property === "https://grafsync.graphifi.com/schema/tsv/concepts" ?
                            "Concepts will output all the concepts as a flat list in a single column"
                            :
                            property === "https://grafsync.graphifi.com/schema/tsv/resources" ?
                                "Resources will output all the resources as a flat list in a single column"
                                :
                                property}>
                        <Typography variant="body2">{title}</Typography>
                    </Tooltip>
                </div>
                <div className={classes.optionLanguage} style={lang.length > 2 ? { width: 44 } : { width: 28 }}>
                    {showLang && <LanguageAvatar data-test="property-lang" lang={lang} />}
                </div>
                <div className={classes.optionDelete}>
                    <Tooltip placement="right" title='Delete column'>
                        <IconButton disabled={disabled} data-test="delete-option" size="small" onClick={removeOption}>
                            <DeleteIcon />
                        </IconButton>
                    </Tooltip>
                </div>
            </div>
            <div className={classes.textBoxExample}>
                <Typography variant="body2" style={{ fontSize: 12, marginBottom: 0, paddingBottom: 0 }}>Examples</Typography>
            </div>
            {examples.map((example, index) => <div data-test={example} key={example} className={classes.textBox}>
                <ResourceLorem
                    labelProp={labelProp}
                    property={property}
                    defaultLang={defaultLang}
                    showLang={showLang}
                    id={examples[index]}
                    lang={lang}
                    graph={graph} />
            </div>
            )}
            {examples.length < 1 && <div className={classes.textBox}></div>}
            {examples.length < 2 && <div className={classes.textBox}></div>}
            {examples.length < 3 && <div className={classes.textBox}></div>}
        </div>;

        return isDraggable ? connectDragSource(tsvOption) : tsvOption;
    }
}

TSVselectedOption.defaultProps = {
    examples: [],
    disabled: false
};

TSVselectedOption.propTypes = {
    isDraggable: PropTypes.bool,
    dragging: PropTypes.bool,
    connectDragSource: PropTypes.func,
    disabled: PropTypes.bool,
    connectDropTarget: PropTypes.func,
    removeOption: PropTypes.func.isRequired,
    lang: PropTypes.string,
    showLang: PropTypes.bool.isRequired,
    graph: PropTypes.string.isRequired,
    examples: PropTypes.array,
    labelProp: PropTypes.string.isRequired,
    defaultLang: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    property: PropTypes.string.isRequired,
    classes: PropTypes.object.isRequired
};

const popt = DragSource(Types.TSVPROP, tsvPropSource, collectSource)(withStyles(styles)(TSVselectedOption));

export default popt;